import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { productSlice } from './slices/productSlice';
import { categorySlice } from './slices/categorySlice';
import { cartSlice } from './slices/cartSlice';
import { wishlistSlice } from './slices/wishlistSlice';
import { authSlice } from './slices/authSlice';
import { userSlice } from './slices/userSlice';
import { searchSlice } from './slices/searchSlice';
import { uiSlice } from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    products: productSlice.reducer,
    categories: categorySlice.reducer,
    cart: cartSlice.reducer,
    wishlist: wishlistSlice.reducer,
    auth: authSlice.reducer,
    user: userSlice.reducer,
    search: searchSlice.reducer,
    ui: uiSlice.reducer,
  },
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
